import { BOARD_COLS, BOARD_ROWS, CELL_EMPTY } from '../constants'

export class Board {
  /** Flat Uint8Array, index = row * BOARD_COLS + col */
  readonly cells: Uint8Array

  constructor() {
    this.cells = new Uint8Array(BOARD_COLS * BOARD_ROWS)
  }

  get(col: number, row: number): number {
    return this.cells[row * BOARD_COLS + col]
  }

  set(col: number, row: number, value: number): void {
    this.cells[row * BOARD_COLS + col] = value
  }

  isEmpty(col: number, row: number): boolean {
    return this.get(col, row) === CELL_EMPTY
  }

  inBounds(col: number, row: number): boolean {
    return col >= 0 && col < BOARD_COLS && row >= 0 && row < BOARD_ROWS
  }

  /**
   * Pull every non-empty cell straight down within its column until it
   * rests on either the bottom or another cell.
   * Returns true if anything actually moved.
   */
  applyGravity(): boolean {
    let moved = false
    for (let col = 0; col < BOARD_COLS; col++) {
      let writeRow = BOARD_ROWS - 1
      for (let row = BOARD_ROWS - 1; row >= 0; row--) {
        const v = this.get(col, row)
        if (v !== CELL_EMPTY) {
          if (writeRow !== row) {
            this.set(col, writeRow, v)
            this.set(col, row, CELL_EMPTY)
            moved = true
          }
          writeRow--
        }
      }
    }
    return moved
  }

  clone(): Board {
    const b = new Board()
    b.cells.set(this.cells)
    return b
  }

  /** Shift every row down by `rows` rows, filling the top with CELL_EMPTY. */
  shiftDown(rows: number): void {
    for (let row = BOARD_ROWS - 1; row >= rows; row--) {
      for (let col = 0; col < BOARD_COLS; col++) {
        this.set(col, row, this.get(col, row - rows))
      }
    }
    for (let row = 0; row < rows; row++) {
      for (let col = 0; col < BOARD_COLS; col++) {
        this.set(col, row, CELL_EMPTY)
      }
    }
  }
}
